// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PartiVotes Theme System
 * 
 * This file defines the CSS variables used throughout the application
 * for consistent theming. It provides a clean way to switch between
 * standard (light) and futuristic (dark/cyberpunk) themes.
 */

:root {
  /* Base colors that don't change between themes */
  --color-white: #ffffff;
  --color-black: #000000;
  --color-error: #f44336;
  --color-success: #4caf50;
  --color-warning: #ff9800;
  
  /* Animation durations */
  --animation-slow: 3s;
  --animation-medium: 2s;
  --animation-fast: 1s;
  
  /* Z-index system */
  --z-index-starfield: -9999;
  --z-index-base: 1;
  --z-index-content: 10;
  --z-index-header: 1100;
  --z-index-footer: 1000;
  --z-index-modal: 2000;
  --z-index-tooltip: 2500;
  --z-index-easter-egg: 3000;
}

/* Standard (Light) Theme Variables */
.standard-theme {
  /* Background colors */
  --background-primary: #f4f6f8;
  --background-secondary: #ffffff;
  --background-tertiary: #e0e0e0;
  
  /* Text colors */
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-tertiary: #999999;
  
  /* Accent colors */
  --accent-primary: #556cd6;
  --accent-secondary: #19857b;
  
  /* Border colors */
  --border-color: #dddddd;
  
  /* Shadow */
  --box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Futuristic (Dark/Cyberpunk) Theme Variables */
.futuristic-theme {
  /* Background colors */
  --background-primary: #121212;
  --background-secondary: #1e1e1e;
  --background-tertiary: #2a2a2a;
  
  /* Text colors */
  --text-primary: #ffffff;
  --text-secondary: #b0b0b0;
  --text-tertiary: #707070;
  
  /* Accent colors */
  --accent-primary: #00fff0; /* Cyan */
  --accent-secondary: #ff00ff; /* Magenta */
  
  /* Cyberpunk color palette - Intensified for better visibility */
  --cyberpunk-cyan: #00fff0;
  --cyberpunk-magenta: #ff00ff;
  --cyberpunk-hot-pink: #ff0055;
  --cyberpunk-neon-green: #00ff77;
  --cyberpunk-neon-orange: #ff9500;
  --cyberpunk-neon-blue: #0099ff;
  --cyberpunk-bright-pink: #ff00aa;
  --cyberpunk-neon-yellow: #ffff00;
  --cyberpunk-electric-blue: #00ddff;
  --cyberpunk-neon-red: #ff3300;
  
  /* Border colors */
  --border-color: #444444;
  
  /* Shadow */
  --box-shadow: 0 2px 10px rgba(0, 255, 240, 0.2);
  
  /* Glow effects */
  --text-glow: 0 0 15px var(--accent-primary);
  --box-glow: 0 0 20px rgba(0, 255, 240, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme-system.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,iDAAiD;EACjD,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;;EAExB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;;EAEpB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;;EAE9B,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;;EAE3B,kBAAkB;EAClB,uBAAuB;;EAEvB,WAAW;EACX,0CAA0C;AAC5C;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;;EAE9B,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,kBAAkB;EAClB,yBAAyB,EAAE,SAAS;EACpC,2BAA2B,EAAE,YAAY;;EAEzC,gEAAgE;EAChE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;;EAE7B,kBAAkB;EAClB,uBAAuB;;EAEvB,WAAW;EACX,+CAA+C;;EAE/C,iBAAiB;EACjB,2CAA2C;EAC3C,2CAA2C;AAC7C","sourcesContent":["/**\n * PartiVotes Theme System\n * \n * This file defines the CSS variables used throughout the application\n * for consistent theming. It provides a clean way to switch between\n * standard (light) and futuristic (dark/cyberpunk) themes.\n */\n\n:root {\n  /* Base colors that don't change between themes */\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-error: #f44336;\n  --color-success: #4caf50;\n  --color-warning: #ff9800;\n  \n  /* Animation durations */\n  --animation-slow: 3s;\n  --animation-medium: 2s;\n  --animation-fast: 1s;\n  \n  /* Z-index system */\n  --z-index-starfield: -9999;\n  --z-index-base: 1;\n  --z-index-content: 10;\n  --z-index-header: 1100;\n  --z-index-footer: 1000;\n  --z-index-modal: 2000;\n  --z-index-tooltip: 2500;\n  --z-index-easter-egg: 3000;\n}\n\n/* Standard (Light) Theme Variables */\n.standard-theme {\n  /* Background colors */\n  --background-primary: #f4f6f8;\n  --background-secondary: #ffffff;\n  --background-tertiary: #e0e0e0;\n  \n  /* Text colors */\n  --text-primary: #333333;\n  --text-secondary: #666666;\n  --text-tertiary: #999999;\n  \n  /* Accent colors */\n  --accent-primary: #556cd6;\n  --accent-secondary: #19857b;\n  \n  /* Border colors */\n  --border-color: #dddddd;\n  \n  /* Shadow */\n  --box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Futuristic (Dark/Cyberpunk) Theme Variables */\n.futuristic-theme {\n  /* Background colors */\n  --background-primary: #121212;\n  --background-secondary: #1e1e1e;\n  --background-tertiary: #2a2a2a;\n  \n  /* Text colors */\n  --text-primary: #ffffff;\n  --text-secondary: #b0b0b0;\n  --text-tertiary: #707070;\n  \n  /* Accent colors */\n  --accent-primary: #00fff0; /* Cyan */\n  --accent-secondary: #ff00ff; /* Magenta */\n  \n  /* Cyberpunk color palette - Intensified for better visibility */\n  --cyberpunk-cyan: #00fff0;\n  --cyberpunk-magenta: #ff00ff;\n  --cyberpunk-hot-pink: #ff0055;\n  --cyberpunk-neon-green: #00ff77;\n  --cyberpunk-neon-orange: #ff9500;\n  --cyberpunk-neon-blue: #0099ff;\n  --cyberpunk-bright-pink: #ff00aa;\n  --cyberpunk-neon-yellow: #ffff00;\n  --cyberpunk-electric-blue: #00ddff;\n  --cyberpunk-neon-red: #ff3300;\n  \n  /* Border colors */\n  --border-color: #444444;\n  \n  /* Shadow */\n  --box-shadow: 0 2px 10px rgba(0, 255, 240, 0.2);\n  \n  /* Glow effects */\n  --text-glow: 0 0 15px var(--accent-primary);\n  --box-glow: 0 0 20px rgba(0, 255, 240, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
